//  ----------      START   IMPORT  BLOCK       ----------
//  API
import APIService from '../Core/APIService';
//  Config
import API_ROUTES from '../../ConfigFiles/Routes/api_routes';
// Types
import type { 
    UserCreateAgendaParams, 
    ProfessionalCreateAgendaParams, 
    UpdateAgendaParams, 
    AgendaEntryResponse,
    WeeklyAgendaResponse
} from '../../Types/schema-helpers';
//  ----------      END   IMPORT  BLOCK       ----------


export default class AgendaService extends APIService {
  /**
   * Creates a new agenda entry for a standard user/patient.
   */
  async createUserAppointment(payload: UserCreateAgendaParams): Promise<AgendaEntryResponse> {
    const route = API_ROUTES.create_user_entry;
    return this.post<AgendaEntryResponse>(route, payload);
  }

  /**
   * Creates a new agenda entry directly by a professional.
   */
  async createProfessionalAppointment(payload: ProfessionalCreateAgendaParams): Promise<AgendaEntryResponse> {
    const route = API_ROUTES.create_pro_entry;
    return this.post<AgendaEntryResponse>(route, payload);
  }

  /**
   * Fetches the weekly schedule for a given medic.
   */
  async fetchWeeklySchedule(medicUsername: string, year: number, week: number): Promise<WeeklyAgendaResponse> {
    const route = API_ROUTES.fetch_weekly_schedule(medicUsername, year, week);
    return this.get<WeeklyAgendaResponse>(route);
  }

  /**
   * Updates an existing agenda entry.
   */
  async updateAgendaEntry(entryId: string, updateData: UpdateAgendaParams): Promise<AgendaEntryResponse> {
    const route = API_ROUTES.update_agenda_entry(entryId);
    return this.patch<AgendaEntryResponse>(route, updateData);
  }

  /**
   * Deletes (cancels) an agenda entry.
   */
  async deleteAgendaEntry(entryId: string): Promise<void> {
  const route = API_ROUTES.delete_agenda_entry(entryId); // resolves to 'agenda/entries/12345'
  //return this.delete<void>(route);
}
}
